export default [
  {
    path: '/gzh/mycourse',
    component: resolve => require(['@/pages/activity/my/mycourse.vue'], resolve)
  },
  {
    path: '/gzh/courselist',
    component: resolve => require(['@/pages/activity/my/courselist.vue'], resolve)
  },
  {
    path: '/overseas/courselist',
    component: resolve => require(['@/pages/activity/my/overseas-courselist.vue'], resolve)
  },
  {
    path: '/gzh/aggregateact',  //聚合页
    component: resolve => require(['@/pages/activity/combine/index.vue'], resolve)
  },
  {
    path: '/gzh/aggregatenew',  //聚合页2
    component: resolve => require(['@/pages/activity/combine/index2.vue'], resolve)
  },
  {
    path: '/gzh/ldsuccess',  //律动英语领取成功
    component: resolve => require(['@/pages/activity/combine/lvdongsuccess.vue'], resolve)
  },
  {
    path: '/gzh/videopage',  //律动英语领取成功
    component: resolve => require(['@/pages/activity/combine/videopage.vue'], resolve)
  },
  // 孵化器流量课
  {
    path: '/gzh/trafficcourse',
    component: resolve => require(['@/pages/activity/my/fuhuaqi/courselist.vue'], resolve)
  },
  {
    path: '/gzh/actentry',
    component: resolve => require(['@/pages/activity/my/fuhuaqi/actentry.vue'], resolve)
  },
  {
    path: '/gzh/partlist',
    component: resolve => require(['@/pages/activity/my/fuhuaqi/partlist.vue'], resolve)
  },
  {
    path: '/gzh/lessonlist',
    component: resolve => require(['@/pages/activity/my/fuhuaqi/lessonlist.vue'], resolve)
  },
  {
    path: '/gzh/llkreport',
    component: resolve => require(['@/pages/activity/my/fuhuaqi/report.vue'], resolve)
  },
  {
    path: '/gzh/reciveSuccess',
    component: resolve => require(['@/pages/activity/reciveSuccess.vue'], resolve)
  },
]